import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Overlay from '../Overlay';
import ErrorBoundary from '../../../../ErrorBoundary';
import { getDeviationTitle } from '../../../_helpers';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import PollOverlay from './PollOverlay';
import overlayHelperStyles from '../OverlayHelpers.scss';
import s from './PollThumb.scss';
var PollThumb = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    return (React.createElement("div", { className: classnames(s['root'], overlayHelperStyles['hoverable'], className), style: __assign({ width: width,
            height: height }, style) },
        React.createElement(ErrorBoundary, { debugComponent: "PollThumb" },
            React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
            React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: getDeviationTitle(deviation) },
                React.createElement("span", null)),
            React.createElement(Overlay, { deviation: deviation, width: width, height: height, underlayClassName: s['overlay'], largeArtist: true, extraActions: extraActions },
                React.createElement(PollOverlay, { deviation: deviation, className: s['poll-overlay'] })))));
};
PollThumb.displayName = 'PollThumb';
export default PollThumb;
//# sourceMappingURL=PollThumb.js.map